import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslateService } from '../../../app/translate';
import { CurrentSelection, Customer, Equipment, JobSite, Make, SelectionLists } from '../../../app/entities';
import { AppService } from '../../app.service';
import { System } from '../wsre-search-on-equipment/wsre-search-on-equipment.component';
import { LoadingService } from '../../../app/shared/services/loading.service';
import { InventoryService } from '../inventory/inventory-service.service';
import { SetupEquipmentService } from '../setup-equipment/setup-equipment.service';
import { FrameVM, InventorySearchItems, ModelCreateInspection, SystemComponentViewModel, SystemsInInventoryViewModel, WSRECreateIdlerVM } from '../inventory/inventory-models';
import { FormControl } from '@angular/forms';
import { JobsiteSelectItem } from '../setup-equipment/setup-equipment.model';
import { NotificationsService } from 'angular2-notifications';
import { OrdinalDateAdapter, ORD_DATE_FORMATS } from '../GET_NEW_UI/adapters/ordinal-date-adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-wsre-quick-frame',
  templateUrl: './wsre-quick-frame.component.html',
  styleUrls: ['./wsre-quick-frame.component.scss'],
  providers: [
    {
        provide: DateAdapter, useClass: OrdinalDateAdapter
    },
    {
        provide: MAT_DATE_FORMATS, useValue: ORD_DATE_FORMATS
    }
]
})
export class WsreQuickFrameComponent implements OnInit {
  translateSubscription: Subscription;
  userLanguage = "english";
  _loading = 0;
  _dropDownLists: SelectionLists = new SelectionLists();
  _dropDownListsFiltered: SelectionLists = new SelectionLists();
  _currentSelection: CurrentSelection = new CurrentSelection();
  _returnRoute = "";
  _selectedEquipment: Equipment = new Equipment();
  //separatorKeysCodes = [ENTER, COMMA];

  items: SystemsInInventoryViewModel[] = [];
  inventorySearchFilter: InventorySearchItems = new InventorySearchItems(2000); // todo : should implement paged table

  equipmentCtrl: FormControl;

  filteredSystems: SystemsInInventoryViewModel[] = [];

  selectedCustomer: Customer;
  isLoading = false;
  selectedJobsite: JobSite;
  selectedMake: Make;
  selectedModel: number;
  private _listFilter: string;

  totalcount = 0;
  avaragecmu = 0;
  chainId: number;
  jobSiteID: number;
  componenetsdetails: SystemComponentViewModel[];

  SystemId: number;
  selected_customerRef: string;
  selected_jobNumber: string;
  selected_oldJobNo: string;
  selected_date: Date = new Date();
  componentList: SystemComponentViewModel[]
  componentList_: SystemComponentViewModel[]
  modelList: JobsiteSelectItem[];
  CopymodelList: JobsiteSelectItem[];

  selectedFrameLSide: number;
  selectedFrameRSide: number;
  selected_FrameNoLeft: string = ""
  selected_FrameNoRight: string = ""
  selected_customerFrameLeft: string
  selected_customerFrameRight: string


  leftSideFrameinfo: WSRECreateIdlerVM[]
  rightSideFrameinfo: WSRECreateIdlerVM[]

  isInventory:boolean =false;



  selected_frame_L: string;
  selected_frame_R: string;
  selected_frame_L_Id:number;
  selected_frame_R_Id:number;
  jobsites :number;

  isCreateNew:boolean=false;

  selectedFrameSide:number=0;

  public get listFilter(): string {
    return this._listFilter;
  }
  public set listFilter(v: string) {
    this._listFilter = v;
    this.filteredSystems = this.listFilter
      ? this.performFilter(this.listFilter)
      : this.items;
  }

  performFilter(filter: string): SystemsInInventoryViewModel[] {
    filter = filter.toLowerCase();
    return this.items.filter(s => {
      // tslint:disable-next-line:no-unused-expression
      return s.SerialNumber.toLowerCase().indexOf(filter) !== -1;
    });
  }
  constructor(public dialogRef: MatDialogRef<WsreQuickFrameComponent>,
    private _appService: AppService,
    private _translate: TranslateService,
    public snackBar: MatSnackBar,
    private _notify: NotificationsService,
    private _loadingService: LoadingService,
    private inventoryService: InventoryService,

    private _equipmentService: SetupEquipmentService,
    private ref: ChangeDetectorRef,
    private _router: ActivatedRoute, private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.SystemId = this._router.snapshot.params.id;

    this._appService.setPageTitle("Frame Setup");

    this.isInventory = this.data.isInventory;
    this.inventorySearchFilter.SerialNo="";
    this.inventorySearchFilter.ModelId=0;
    this.inventorySearchFilter.CustomerId=0;
    this.inventorySearchFilter.JobsiteId=0;
    this.inventorySearchFilter.MakeId=0;

    //this.selectedFrameSide =this.data.selectedFrameSide;
    this.selected_frame_L = this.data.selected_frame_L;
    this.selected_frame_R = this.data.selected_frame_R;
    this.selected_frame_L_Id = this.data.selected_frame_L_Id;
    this.selected_frame_R_Id = this.data.selected_frame_R_Id;
    this.jobsites = this.data.jobsites;
    this.isCreateNew =this.data.isCreateNew;
    this.selectedFrameLSide=this.data.selected_frame_L_Id;
    this.selectedFrameRSide=this.data.selected_frame_R_Id;


    if(this.isCreateNew==true){
      this.selectedFrameSide =this.data.selectedFrameSide;
    }

    console.log("data", this.data,this.isInventory)
    this._loading++;
    this._appService.getCustomerListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.customerList = result;
        this._dropDownListsFiltered.customerList = result;
      },
      error => {
        console.error(error);
      },
      () => {
        this._loading--;
      }
    );
    this._loading++;
    this._appService.getJobSiteListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.jobSiteList = result;
      },
      error => {
        console.error(error);
      },
      () => {
        this._loading--;
      }
    );
    this._loading++;
    this._appService.getMakeListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.makeList = result;
      },
      error => {
        console.error(error);
      },
      () => {
        this._loading--;
      }
    );
    this._loading++;
    this._appService.getModelListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.modelList = result;
      },
      error => {
        console.error(error);
      },
      () => {
        this._loading--;
      }
    );

    this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));
  }
  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }
  updateUserLang(lang: string) {
    this.userLanguage = lang;
    this.ref.detectChanges();
  }


  isWSREEnable: boolean = false;
  arrSystems: System[];

  frameSystemsL:SystemsInInventoryViewModel[];
  frameSystemsR:SystemsInInventoryViewModel[];
  LoadingSpinner:boolean=false;
   LoadFrames() {
     this.LoadingSpinner=true;
     this.inventorySearchFilter.IncludeWSRE= true;
     this.inventorySearchFilter.PageNumber = 1;
    this._loadingService.startLoading();
    this.isLoading = true;
    this.inventoryService
      .searchSystemInInventory(this.inventorySearchFilter)
      .subscribe(
        r => {
          if(r!=null){
          this.items = r.ListSystemInventory;
          if(r.ListSystemInventory!=null){
          let _filteredSystems = r.ListSystemInventory.filter(f => f.SystemTypeName =="Frame");
          this.filteredSystems = _filteredSystems;
          this.frameSystemsL = _filteredSystems.filter(f=>f.Side=="Left");
          this.frameSystemsR = _filteredSystems.filter(f=>f.Side=="Right");
          }
   
          console.log("filteredSystemsL", this.frameSystemsL)
          console.log("filteredSystemsR", this.frameSystemsR)

          this.LoadingSpinner=false;
      
          this.finishedLoading();
           
        }else{
          this.LoadingSpinner=false;
        }
        },
        error => {
          this.finishedLoading();
        }

       
      );
  }
  ChangeSystemL(){
    console.log("Chnage Left", this.filteredSystems,this.frameSystemsR)
    this.frameSystemsR = this.filteredSystems;
    
    this.frameSystemsR = this.frameSystemsR.filter(x=>x.SystemId!=this.selectedFrameLSide)
  }
  ChangeSystemR(){
    console.log("Chnage Right", this.filteredSystems,this.frameSystemsL)
    this.frameSystemsL= this.filteredSystems;
    this.frameSystemsL = this.frameSystemsL.filter(x=>x.SystemId!=this.selectedFrameRSide)
  }
  finishedLoading() {
    this._loadingService.finishedLoading();
    this.isLoading = false;
  }

  customerChanged(event: any): void {
    this.selectedCustomer = event.value;
    if (!this.selectedCustomer) {
      return;
    }
    this._dropDownListsFiltered.jobSiteList = this._dropDownLists.jobSiteList.filter(
      m => m.CustomerId === this.selectedCustomer.Id
    );
    this.inventorySearchFilter.CustomerId = this.selectedCustomer.Id;
    this.inventorySearchFilter.JobsiteId = 0;
    this.selectedJobsite = null;


  }

  jobsiteChanged(event: any): void {
    this.selectedJobsite = event.value;
    if (!this.selectedJobsite) {
      return;
    }
    this.inventorySearchFilter.JobsiteId = this.selectedJobsite.Id;

  }

  makeChanged(event) {
    this.selectedMake = event.value;
    if (!this.selectedMake) {
      return;
    }
    this.inventorySearchFilter.MakeId = this.selectedMake.Id;

    // this._dropDownListsFiltered.modelList = this._dropDownLists.modelList.filter(
    //   m => m.MakeId === this.selectedMake.Id
    // );

    this._equipmentService.getModelList(this.selectedMake.Id).subscribe(res => {
      this.modelList = res;
      this.CopymodelList = res;
    });
    //  this.search();
  }


  // GetFrameList(){
  //   this.inventoryService.GetFrameForSelectedModel(this.selectedModel).subscribe(res=>{
  //     console.log("componentlist", res)
  //     this.componentList = res;
  //   })
  // }

  onNoClick() {
    this.dialogRef.close(true);
  }

  onClickStartInspection(){
    console.log("Inve", this.isInventory, this.isCreateNew)
    if(this.isInventory==false){
      this.StartInspection_FrameSetup();
    }else{
      console.log("Start Inspection Frame")
      this.StartInspection_FrameInventory();
    }
  }

  StartInspection_FrameInventory(){
    if(this.isCreateNew==false){
      if(this.selectedFrameSide==3)
      this.CreateIdlerInspection(0,this.selectedFrameLSide,0, this.selectedFrameRSide);
      else if(this.selectedFrameSide==1)
      this.CreateIdlerInspection(0,this.selectedFrameLSide,0, 0);
      else if(this.selectedFrameSide==2)
      this.CreateIdlerInspection(0,0,0, this.selectedFrameRSide);


    }
    else{
      console.log("Start Inspection Frame New")
      if(this.selectedFrameSide==3)
      this.CreateFrameInspectionNew(0,this.selectedFrameLSide,0, this.selectedFrameRSide);
      else if(this.selectedFrameSide==1)
      this.CreateFrameInspectionNew(0,this.selectedFrameLSide,0, 0);
      else if(this.selectedFrameSide==2)
      this.CreateFrameInspectionNew(0,0,0, this.selectedFrameRSide);


     

    }
    
  }


  StartInspection_FrameSetup() {
    let arr_ = []
    let arr = [];
    //create frame 
    let ob1 = new FrameVM()
    ob1.compartid = this.selectedFrameLSide
    ob1.srialNo = this.selected_FrameNoLeft
    ob1.side = 1

    let ob2 = new FrameVM()
    ob2.compartid = this.selectedFrameRSide
    ob2.srialNo = this.selected_FrameNoRight
    ob2.side = 2

if(this.selectedFrameSide==3){
// arr.push(ob1,ob2)
arr[0] = ob1
arr[1] = ob2
}else if(this.selectedFrameSide==1){
  arr[0] = ob1
}else if(this.selectedFrameSide==2){
  arr[0] = ob2
}
    

    console.log("arr for left side and right side", arr)


    console.log("arr[i].compartid", arr[0].compartid)
    console.log("arr[i].compartid", arr[0].srialNo)
    console.log("arr[i].compartid", arr[0].side)
    console.log("arr[i].compartid", arr[1].compartid)
    console.log("arr[i].compartid", arr[1].srialNo)
    console.log("arr[i].compartid", arr[1].side)
    for (let i = 0; i < arr.length; i++) {
      this.inventoryService.CeateFrameAndGEWForFrameWSRE(arr[i].compartid, this.selectedJobsite.Id, this.selectedMake.Id, this.selectedModel, arr[i].srialNo, arr[i].side).subscribe(result => {
        // console.log("data", result)
        arr_.push(result)
        console.log("arr_", arr_)
        
        this.leftSideFrameinfo = arr_.filter(a => a.side == 1)
        this.rightSideFrameinfo = arr_.filter(a => a.side == 2)
        console.log("this.leftSideFrameinfo", this.leftSideFrameinfo)
        console.log("this.rightSideFrameinfo", this.rightSideFrameinfo)
       
          if (this.leftSideFrameinfo[0].EqunitId > 0 && this.leftSideFrameinfo[0].EqunitId > 0 && this.rightSideFrameinfo[0].SystemId > 0 && this.rightSideFrameinfo[0].SystemId > 0) {
    console.log("obj____B",this.selectedFrameSide)

            this.CreateIdlerInspection(this.leftSideFrameinfo[0].EqunitId, this.leftSideFrameinfo[0].SystemId, this.rightSideFrameinfo[0].EqunitId, this.rightSideFrameinfo[0].SystemId)
          }
        
        
      })
    }


  }

  CreateIdlerInspection(EqunitId: number, SysId: number, EqunitIdR: number, SysIdR: number) {
    console.log("JobSiteId", this.selectedJobsite.Id)
    console.log("selected_oldJobNo", this.selected_oldJobNo)
    console.log("selected_customerRef", this.selected_customerRef)
    console.log("selected_jobNumber", this.selected_jobNumber)
    console.log("selected_date", this.selected_date)

    let obj_ = new ModelCreateInspection()

    obj_["_date"] = this.selected_date
    obj_["_jobSiteId"] = this.selectedJobsite.Id
    obj_["_systemId"] = SysId
    obj_["_jobNumber"] = this.selected_jobNumber
    obj_["_customerRef"] = this.selected_customerRef
    obj_["_oldJobNo"] = this.selected_oldJobNo
    obj_["SystemTypeId"] = 2
    obj_["EqunitId"] = EqunitId
    obj_["TrackFrame_Right_SystemId"] = SysIdR
    obj_["TrackFrame_Customer_L_Serial"] = this.selected_customerFrameLeft
    obj_["TrackFrame_Customer_R_Serial"] = this.selected_customerFrameRight
    obj_["FrameInspectedSide"] = this.selectedFrameSide;
    obj_["StringDate"] = this.datePipe.transform( this.selected_date, 'MM/dd/yyyy');
    
    console.log("obj____", obj_,this.selectedFrameSide)
    this._loadingService.startLoading();
    this.isLoading = true;
    this.inventoryService.POSTCreateWSREInspectionFrame(obj_).subscribe(r => {
      console.log("r", r)

      if (r._status) {
        this.onNoClick()
        this.router.navigate(['/repair-estimate-frame', r._inspectionID, 3])
        .then(()=>{
          window.location.reload();
        });
       
        //window.open('/product-improvement-program/' + r._inspectionID + 3);
   // window.open('/repair-estimate-frame/'+  r._inspectionID+ '/'+3 );   
        
       // this.ngOnInit()
      } else {
      }
      this.finishedLoading();
    })



  }

  CreateFrameInspectionNew(EqunitId: number, SysId: number, EqunitIdR: number, SysIdR: number) {
    console.log("JobSiteId", this.jobsites)
    console.log("selected_oldJobNo", this.selected_oldJobNo)
    console.log("selected_customerRef", this.selected_customerRef)
    console.log("selected_jobNumber", this.selected_jobNumber)
    console.log("selected_date", this.selected_date)

    let obj_ = new ModelCreateInspection()

    obj_["_date"] = this.selected_date
    obj_["_jobSiteId"] = this.jobsites
    obj_["_systemId"] = SysId
    obj_["_jobNumber"] = this.selected_jobNumber
    obj_["_customerRef"] = this.selected_customerRef
    obj_["_oldJobNo"] = this.selected_oldJobNo
    obj_["SystemTypeId"] = 2
    obj_["EqunitId"] = EqunitId
    obj_["TrackFrame_Right_SystemId"] = SysIdR
    obj_["TrackFrame_Customer_L_Serial"] = this.selected_customerFrameLeft
    obj_["TrackFrame_Customer_R_Serial"] = this.selected_customerFrameRight
    obj_["FrameSerial_Left"] = this.selected_frame_L
    obj_["FrameSerial_Right"] = this.selected_frame_R

    obj_["FrameInspectedSide"] = this.selectedFrameSide;
    obj_["StringDate"] = this.datePipe.transform( this.selected_date, 'MM/dd/yyyy');

    console.log("obj____", obj_)
    this._loadingService.startLoading();
    this.isLoading = true;
    this.inventoryService.POSTCreateWSREInspectionFrame(obj_).subscribe(r => {
      console.log("r", r)

      if (r._status) {
        this.onNoClick()
        this.router.navigate(['/repair-estimate-frame', r._inspectionID, 3])
        .then(()=>{
          window.location.reload();
        });
       
        //window.open('/product-improvement-program/' + r._inspectionID + 3);
   // window.open('/repair-estimate-frame/'+  r._inspectionID+ '/'+3 );   
        
       // this.ngOnInit()
      } else {
      }
      this.finishedLoading();
    })



  }
  changeModelAutoComplete(event) {
    const filterValue = event.target.value.toLowerCase();

    this.modelList = this.CopymodelList.filter(option => option.Name.toLowerCase().includes(filterValue));
  }

  modelTitle: String;
  model_auto_: number;

  modelselect(modelid) {
    console.log("this.modelTitle", modelid, this.modelList)

    this.model_auto_ = this.modelList.find(f => f.Name == modelid).Id;
    this.selectedModel = this.modelList.find(f => f.Name == modelid).Id;

    console.log("model_auto_", this.model_auto_, this.selectedModel)
    this.inventorySearchFilter.ModelId = this.selectedModel;
    this.inventoryService.GetFrameForSelectedModelLeft(this.selectedModel).subscribe(res => {

      this.componentList = res;

      if(this.componentList.length==1){
        this.selectedFrameLSide = this.componentList[0].CompartId;
      }
      // this.componentListLEFT=  this.componentList.filter
    })

    this.inventoryService.GetFrameForSelectedModelRight(this.selectedModel).subscribe(res => {

      this.componentList_ = res;
      if(this.componentList_.length==1){
        this.selectedFrameRSide = this.componentList_[0].CompartId;
      }
      // this.componentListLEFT=  this.componentList.filter
    })

  }

  checkSerialNoLeft(event) {
    this.selected_FrameNoLeft = event.target.value
    if(this.selected_FrameNoLeft!=""){
    
    this.inventoryService.VerifyserilaNo(event.target.value).subscribe(res => {

      if (res == false) {
        this._notify.error('Operation failed!', 'That system serial number already exists! Please enter a valid serial number');
      }
      else {
        this._notify.success('Serial number validated');
      }

    })
  }
  }

  checkSerialNoRight(event) {
    this.selected_FrameNoRight = event.target.value
    if( this.selected_FrameNoRight!=""){
    if (this.selected_FrameNoLeft == this.selected_FrameNoRight) {
      this._notify.error('Operation failed!', 'That system serial numbers cannot be same! Please enter a valid serial number');
    }
    else {
      this.inventoryService.VerifyserilaNo(event.target.value).subscribe(res => {

        if (res == false) {
          this._notify.error('Operation failed!', 'That system serial number already exists! Please enter a valid serial number');
        }
        else {
          this._notify.success('Serial number validated');
        }

      })

    }
  }

  }

  getCustomerFrameNoLeft(event) {
    this.selected_customerFrameLeft = event.target.value
  }
  getCustomerFrameNoRight(event) {
    this.selected_customerFrameRight = event.target.value
  }
  getDate(event){
    this.selected_date=event.target.value
  }
  getCustomerReference(event){
    this.selected_customerRef=event.target.value
    }

  getJobNumber(event){
    this.selected_jobNumber=event.target.value
    }

  getOldJobNumber(event){
    this.selected_oldJobNo=event.target.value
    }

    showSelectedSide(id:number){
      if(id==3){
        this.inventorySearchFilter.ShowBoth=true;
      }else{
        this.inventorySearchFilter.ShowBoth=false;

      }
console.log("selectedFrameSide",this.selectedFrameSide)
    }
}
